module.exports = __webpack_public_path__ + "static/media/mahindra.c49727ec.jpg";